module.exports = __webpack_public_path__ + "img/trklogo (1).0ce8037a.png";